import {
  LMS_INIT_REQUEST,
  LMS_INIT_SUCCESS,
  UPDATE_QUERY,
  FILTER_REQUEST,
  FILTER_REQUEST_SUCCESS,
  LOAD_MORE_REQUEST,
  LOAD_MORE_SUCCESS,
  LOAD_MORE_FAILURE,
  SORT_REQUEST,
  SORT_SUCCESS,
  SORT_FAILURE,
  EXPONEA_PUSH,
} from './constants';

export const initLmsAction = () => ({ type: LMS_INIT_REQUEST });

export const exponeaInitAction = (payload = {}, exponea = {}) => {
  return {
    type: EXPONEA_PUSH,
    payload,
    meta: {
      exponea,
    },
  };
};

export const initLmsSuccessAction = (data, meta = {}) => {
  return {
    type: LMS_INIT_SUCCESS,
    payload: data,
    meta,
  };
};

export const updateQuery = (updates, gtm) => {
  const updatesAsStrings = {};
  Object.keys(updates).forEach((key) => {
    const normalizedKey = key.replace(/\W/g, '');
    if (
      typeof updates[key] === 'string' ||
      typeof updates[key] === 'number' ||
      typeof updates[key] === 'boolean'
    ) {
      updatesAsStrings[normalizedKey] = `${updates[key]}`;
    } else if (Array.isArray(updates[key])) {
      updatesAsStrings[normalizedKey] = updates[key].join(',');
    }
  });

  return {
    type: UPDATE_QUERY,
    payload: updatesAsStrings,
    meta: {
      gtm,
    },
  };
};

export const filterRequestAction = (payload = {}) => ({
  type: FILTER_REQUEST,
  payload,
});

export const filterRequestSuccessAction = (payload, meta = {}) => ({
  type: FILTER_REQUEST_SUCCESS,
  payload,
  meta,
});

export const loadMoreRequestAction = () => ({ type: LOAD_MORE_REQUEST });
export const loadMoreSuccessAction = (payload, meta = {}) => ({
  type: LOAD_MORE_SUCCESS,
  payload,
  meta,
});
export const loadMoreFailureAction = (error) => ({ type: LOAD_MORE_FAILURE, payload: error });

export const sortRequestAction = () => ({ type: SORT_REQUEST });
export const sortSuccessAction = (payload, meta = {}) => ({ type: SORT_SUCCESS, payload, meta });
export const sortFailureAction = (error) => ({ type: SORT_FAILURE, payload: error });
